import { render, staticRenderFns } from "./medical-contacts-form.vue?vue&type=template&id=f84d02c8&scoped=true"
import script from "./medical-contacts-form.vue?vue&type=script&lang=js"
export * from "./medical-contacts-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84d02c8",
  null
  
)

export default component.exports